import { defineMessages } from 'react-intl'

export const lang = defineMessages({
    currencyForPayment: {
        id: 'new_cards.currency_for_payment',
        defaultMessage: 'Currency for payment',
    },
    less: {
        id: 'new_cards.less',
        defaultMessage: 'Not enough funds.',
    },
})
